import React from 'react'
import { array, string } from 'prop-types'

import Grid from '../../Grid'
import Card from '../../Card'
import Surround from '../../Surround'
import Tag from '../../Tag'

const CardGrid12 = ({ articles }) => {
  if (!articles.length) return null

  const landscapeImageRatio = 126 / 167
  const widescreenImageRatio = 375 / 668

  const SmallGrid = ({ hidden }) => (
    <Grid.Item hidden={hidden} width={{ d: 1 / 3 }}>
      <Grid>
        {articles[4] && (
          <Grid.Item trailingGap="default">
            <Surround padded="default" bordered="default">
              <Card
                typeConfig={{
                  title: {
                    size: ['body2', 'heading8'],
                    weight: 'medium',
                    themed: true
                  }
                }}
                horizontal
                {...{
                  ...articles[4],
                  description: '',
                  sizes: [
                    '(min-width: 1420px) 137px',
                    '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                    'calc(50vw - 80px)'
                  ],
                  width: 137
                }}
                imageRatio={landscapeImageRatio}
                src={articles[4].src}
              />
            </Surround>
          </Grid.Item>
        )}
        {articles[5] && (
          <Grid.Item trailingGap={hidden === 'mobile' ? 'desktop' : null}>
            <Surround
              padded={hidden === 'mobile' ? 'desktop' : null}
              bordered={hidden === 'mobile' ? 'desktop' : null}
            >
              <Card
                typeConfig={{
                  title: {
                    size: ['body2', 'heading8'],
                    weight: 'medium',
                    themed: true
                  }
                }}
                horizontal
                {...{
                  ...articles[5],
                  description: '',
                  sizes: [
                    '(min-width: 1420px) 137px',
                    '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                    'calc(50vw - 80px)'
                  ],
                  width: 137
                }}
                imageRatio={landscapeImageRatio}
                src={articles[5].src}
              />
            </Surround>
          </Grid.Item>
        )}
      </Grid>
    </Grid.Item>
  )

  SmallGrid.propTypes = {
    hidden: string
  }

  return (
    <Grid flex gutter="default">
      <Grid.Item hidden="mobile" width={{ d: 2 / 3 }} trailingGap="default">
        <Card
          typeConfig={{
            title: { size: ['heading7', 'heading5'], themed: true },
            description: { size: ['body2', 'body4'] }
          }}
          contentBorder={['top']}
          horizontal
          inverse={articles[0].featured}
          inset={articles[0].featured}
          headerComponents={() => {
            if (!articles[0].featured) return null
            return (
              <Tag themedFont background="white">
                Featured
              </Tag>
            )
          }}
          {...{
            ...articles[0],
            sizes: ['(min-width: 1420px) 304px', 'calc(25vw - 32px - 80px)'],
            width: 304
          }}
          gridWidths={[1 / 2, 1 / 2]}
          gridGutter="large"
          imageRatio={landscapeImageRatio}
          src={articles[0].src}
        />
      </Grid.Item>
      <Grid.Item hidden="desktop" width={{ d: 2 / 3 }} trailingGap="default">
        <Card
          typeConfig={{
            title: {
              size: ['heading7', 'heading6'],
              weight: 'medium',
              themed: true
            }
          }}
          inverse={articles[0].featured}
          inset={articles[0].featured}
          {...{ ...articles[0], sizes: ['calc(50vw - 80px)'], width: 304 }}
          imageRatio={landscapeImageRatio}
          src={articles[0].src}
          headerComponents={() => {
            if (!articles[0].featured) return null
            return <Tag background="white">Featured</Tag>
          }}
        />
      </Grid.Item>
      <SmallGrid hidden="mobile" />
      {articles[1] && (
        <Grid.Item width={{ d: 1 / 3 }} trailingGap="default">
          <Surround padded="mobile" bordered="mobile">
            <Card
              typeConfig={{
                title: {
                  size: ['heading7', 'heading6'],
                  weight: 'medium',
                  themed: true
                }
              }}
              {...{
                ...articles[1],
                description: '',
                sizes: [
                  '(min-width: 1420px) 322px',
                  '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                  'calc((100vw - 80px) * 0.5)'
                ],
                width: 322
              }}
              imageRatio={widescreenImageRatio}
              src={articles[1].src}
            />
          </Surround>
        </Grid.Item>
      )}
      {articles[2] && (
        <Grid.Item width={{ d: 1 / 3 }} trailingGap="mobile">
          <Surround padded="mobile" bordered="mobile">
            <Card
              typeConfig={{
                title: {
                  size: ['heading7', 'heading6'],
                  weight: 'medium',
                  themed: true
                }
              }}
              {...{
                ...articles[2],
                description: '',
                sizes: [
                  '(min-width: 1420px) 322px',
                  '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                  'calc((100vw - 80px) * 0.5)'
                ],
                width: 322
              }}
              imageRatio={widescreenImageRatio}
              src={articles[2].src}
            />
          </Surround>
        </Grid.Item>
      )}
      {articles[3] && (
        <Grid.Item hidden="mobile" width={{ d: 1 / 3 }} trailingGap="mobile">
          <Card
            typeConfig={{
              title: {
                size: ['heading7', 'heading6'],
                weight: 'medium',
                themed: true
              }
            }}
            {...{
              ...articles[3],
              description: '',
              sizes: [
                '(min-width: 1420px) 322px',
                '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                'calc((100vw - 80px) * 0.5)'
              ],
              width: 137
            }}
            imageRatio={widescreenImageRatio}
            src={articles[3].src}
          />
        </Grid.Item>
      )}
      <SmallGrid hidden="desktop" />
    </Grid>
  )
}

CardGrid12.propTypes = {
  articles: array
}

export default CardGrid12
